import React from "react";

export const ThanksScreen = ({ endDateTime = "" }) => {
  return (
    <div className="quiz-container">
      <div className="winner-container centerElement">
        <div className="winner-header mb-0">
          <div className="winner-icon">
            <img src="/Images/thumbs-up.png" alt="thumbs-up" />
          </div>
          <h2 className="question-title mt-0 mb-2">
            Thanks for participating!!
          </h2>
          <p>
            Thank you for participating in our contest! Result will be announced
            {endDateTime.includes(" at ")
              ? ` ${endDateTime.split(" at ")[0]}`
              : " soon"}
            &nbsp; at 11:00 PM
          </p>
        </div>
      </div>
    </div>
  );
};
